<template>
  <div style="margin: 20px; width: 100%;">
    <el-row class="pcenter" style="flex-flow: row; justify-content: flex-start;">
      <img class="tx" :src="usertx" />
      <div class="pcenter" style="flex-flow: column; align-items: flex-start; margin-left: 20px;">
        <span style="display:flex; justify-content: flex-start;">姓名：{{username}}</span>
        <span style="display:flex; justify-content: flex-start; margin-top: 10px;">所属企业：{{gs}} 职务：{{zw}}</span>
        <span style="display:flex; justify-content: flex-start; margin-top: 10px;">注册时间：{{regtime}}</span>
      </div>
    </el-row>
    <el-row></el-row>
    <el-row  class="rowfg pcenter" style="margin-top: 20px; padding: 20px; border-top: 1px #ccc dotted;">
      <el-col :span="6"><span style="font-weight: bold;">营业执照</span></el-col>
      <el-col :span="12"><img style="width: 200px; height: 120px" :src="yzurl" /> </el-col>
      <el-col :span="6" class="pcenter selectbtn" style="justify-content: flex-end; color:darkgreen;"><span @click="reuploadzm">重新上传</span></el-col>
    </el-row>
    <el-row  class="rowfg pcenter" style="margin-top: 20px; padding: 20px; border-top: 1px #ccc dotted;">
      <el-col :span="6"><span style="font-weight: bold;">身份证正面</span></el-col>
      <el-col :span="12"><img style="width: 200px; height: 120px" :src="sfzzm" /> </el-col>
      <el-col :span="6" class="pcenter selectbtn" style="justify-content: flex-end; color:darkgreen;"><span @click="reuploadzm">重新上传</span></el-col>
    </el-row>
    <el-row class="rowfg pcenter" style="padding: 20px; border-top: 1px #ccc dotted;">
      <el-col :span="6"><span style="font-weight: bold;">身份证反面</span></el-col>
      <el-col :span="12"><img style="width: 200px; height: 120px" :src="sfzfm" /> </el-col>
      <el-col :span="6" class="pcenter selectbtn" style="justify-content: flex-end; color:darkgreen;"><span @click="reuploadfm">重新上传</span></el-col>
    </el-row>
  </div>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'ShowCusInfo',
    data () {
      return {
        username: '',
        usertx: '',
        zw: '',
        regtime: '',
        sfzzm: '',
        sfzfm: '',
        yzurl: '',
        gs: '',
        fit: 'fill'
      }
    },
    mounted () {
      that = this
      if (localStorage.getItem('userimg') === null || localStorage.getItem('userimg') === '') {
        this.usertx = 'https://sqpro.oss-cn-beijing.aliyuncs.com/admin/img/tx.jpg'
      }
      that.$options.methods.getperson()
      that.$options.methods.getcusinfo()
    },
    methods: {
      getperson () {
        var qstr = 'accountid=' + localStorage.getItem('accountid') + ' and cus_id=' + localStorage.getItem('cusid')
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getcususer',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              if (res.data.data !== '[]') {
                var gtmpdata = JSON.parse(res.data.data)
                that.username = gtmpdata[0].name.String
                that.zw = gtmpdata[0].post.String
                that.regtime = gtmpdata[0].optime.String
                that.sfzfm = gtmpdata[0].sfzfm.String
                that.sfzzm = gtmpdata[0].sfzzm.String
                window.console.log(gtmpdata)
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getcusinfo() {
        var qstr = 'id=' + localStorage.getItem('cusid')
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getcus',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              if (res.data.data !== '[]') {
                var gtmpdata = JSON.parse(res.data.data)
                that.gs = gtmpdata[0].name
                that.yzurl = gtmpdata[0].blnumurl.String
                window.console.log(gtmpdata)
              }
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      reuploadzm () {},
      reuploadfm () {}
    }
  }
</script>

<style scoped>
  .selectbtn {
    cursor:pointer;
  }
  .tx {
    width:100px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/regedit/ShowCusInfo.vue